import * as React from "react";
import type { SVGProps } from "react";
const SvgTikTok = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.375 10.68h-.035c-1.617 0-3.094-.492-4.29-1.371v6.293c0 3.164-2.566 5.695-5.73 5.695a5.67 5.67 0 0 1-5.695-5.695c0-3.165 2.531-5.73 5.695-5.73.282 0 .528.034.809.07v3.163a2.2 2.2 0 0 0-.809-.14 2.656 2.656 0 0 0-2.636 2.637 2.656 2.656 0 0 0 2.636 2.636 2.656 2.656 0 0 0 2.637-2.636V3.297h3.094v.07c0 .246 0 .492.07.738.211 1.16.914 2.18 1.899 2.813a4.1 4.1 0 0 0 2.32.703h.035z"
    />
  </svg>
);
export default SvgTikTok;
